import { ISPFormState, ISPFieldConfig } from 'common/dynamic-form/model';
import { ISPConfigMappers } from 'common/dynamic-form/services/loader/model/config-mapper.interface';
import { getGeneralErrorConfig } from 'common/dynamic-form/types/general-error/general-error.utils';
import { getLayoutConfig } from 'common/dynamic-form/types/layout/layout.utils';
import { TemplateConfig } from 'common/dynamic-form/types/template/model';
import {
  separateTemplatesByInsertingType,
  replaceConfigByTemplates,
} from 'common/dynamic-form/types/template/template.utils';

import { appendConfigWrapperOptions } from './append-config-wrapper-options';
import { getConfigsFromTypedForm } from './get-configs-from-typed-form';
import { getOriginalFieldFromConfig } from './get-original-field-from-config';

import { TypedForm } from '../form-preparing';
import { forEachConfig } from '../formly-configs/for-each-config';
import { sortConfigs } from '../formly-configs/sort-configs';

/**
 * Generate configs from typed form and templates for dynamic-form
 *
 * @param typedForm
 * @param state
 * @param templateConfigs
 * @param mappers
 */
export function generateConfigs(
  typedForm: TypedForm | undefined,
  state: ISPFormState,
  templateConfigs: TemplateConfig[],
  mappers?: Partial<ISPConfigMappers>,
): ISPFieldConfig[] {
  const configs = getConfigsFromTypedForm(typedForm, state, mappers);

  if (!state.showGeneralErrorInNotification) {
    configs.push(getGeneralErrorConfig(state));
  }

  const [templatesToAdd, templatesToReplace] =
    separateTemplatesByInsertingType(templateConfigs);

  const configsWithTemplates = [...configs, ...templatesToAdd];
  const groupedConfigsInLayout = [getLayoutConfig(configsWithTemplates, state)];

  replaceConfigByTemplates(groupedConfigsInLayout, templatesToReplace);
  sortConfigs(groupedConfigsInLayout, (a, b) => {
    const ao = 'order' in a.props ? a.props.order! : 0;
    const bo = 'order' in b.props ? b.props.order! : 0;
    return ao - bo;
  });

  state.customHandlingConfigsFunction?.(groupedConfigsInLayout, state);

  forEachConfig(groupedConfigsInLayout, config => {
    const field = getOriginalFieldFromConfig(config);
    if (!field) {
      return;
    }
    appendConfigWrapperOptions(config, field, state);
  });

  return groupedConfigsInLayout;
}
